import { NgClass } from "@angular/common";
import { Component, HostListener, OnDestroy, OnInit, Renderer2 } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/compat/auth";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { collection, doc, Firestore, getDoc, getDocs } from "@angular/fire/firestore";
import { FormControl, FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { AuthPartialRegService } from "@core/AuthServices/authPartialReg/auth-partial-reg.service";
import { CatchErrorService } from "@core/catch-error.service";
import { LoadingService } from "@core/loading.service";
import { UtilityService } from "@core/utility.service";
import { IonicModule, LoadingController } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { format } from "date-fns";
import { firstValueFrom, from, of, Subscription } from "rxjs";
import { catchError, map, switchMap, take, tap } from "rxjs/operators";
import { CommonVariable } from "src/app/app.constants";
import { GTMSagmentService } from "src/app/services/gtm-sagment.service";
import { PaymentService } from "src/app/services/payment.service";
import { UserManagementService } from "src/app/services/user-management.service";
import { v4 as uuidv4 } from "uuid";
import { SwitchExpressModalComponent } from "../switch-express-modal/switch-express-modal.component";
import { environment } from "src/environments/environment";

declare var window;
@Component({
  selector: "app-age-verification",
  templateUrl: "./age-verification.page.html",
  styleUrls: ["./age-verification.page.scss"],
  standalone: true,
  imports: [
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    NgClass,
    TranslatePipe,
  ],
})
// eslint-disable-next-line no-unused-vars
export class AgeVerificationPage implements OnInit, OnDestroy {
  public iswrap1Expanded: boolean;
  public iswrap2Expanded: boolean;
  public origin: string = window.location.origin;
  public isPaymentDone: boolean;
  public count: number;
  public paymentReceived: boolean;
  public pathString: string;
  public payment_status: Data;
  public insertCustomerPurchaseRes: Data;
  public purchaseDetail: Data;
  public loaded: boolean;
  public myuuid: string;
  public translatedToastMsg: object;
  public selectedLanguage: string;
  public checkoutCreationTime: Date;
  public loading: boolean;
  selectedFile: File | undefined;
  isLoading: boolean;
  public ageVerifyForm: UntypedFormGroup;
  public checkInput: boolean;
  public defaultDateOfBirth: string;
  url: string;
  paymentDetail: Data;
  userDetails: Data;
  hideVerificationMethod: boolean;
  public TP1: string = window.localStorage.getItem("TP1");
  public Tp2: string = window.localStorage.getItem("TP2");
  public TP3: string = window.localStorage.getItem("TP3");
  public T_ID: string = window.localStorage.getItem("T_ID");
  public Prosub_id: number = window.localStorage.getItem("prosub_id");
  spinnerAnimation: boolean;
  addNewCardInProgress: boolean;
  addingCard: boolean;
  altprosubDetails: Data;
  defaultPrice = 0;
  storedCards = [];
  paymentTypePreAuth: string;
  sub_status: string;
  tokenValidaterSub: Subscription;
  storedCardSubscription: Subscription;
  public fbTokenKey = "fbToken";
  public userIdKey = "userId";
  public userId: string;
  constructor(
    private catchService: CatchErrorService,
    private GTMService: GTMSagmentService,
    private angularFireAuth: AngularFireAuth,
    private fb: UntypedFormBuilder,
    public translate: TranslateService,
    private router: Router,
    private matDialog: MatDialog,
    private paymentService: PaymentService,
    private utilityService: UtilityService,
    private angularFirestore: AngularFirestore,
    private loadingService: LoadingService,
    private authService: AuthService,
    private loadingController: LoadingController,
    private AuthPartialRegService: AuthPartialRegService,
    private renderer: Renderer2,
    private userManagementService: UserManagementService,
    private firestore: Firestore,
  ) {
    this.paymentTypePreAuth = "PA";
    this.sub_status = "pre_auth";
    this.hideVerificationMethod = true;
    this.checkInput = false;
    this.isPaymentDone = false;
    this.isLoading = false;
    this.count = 0;
    this.authService.selectedlanguage$.subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : CommonVariable.preferredLanguage);
      },
      (err) => {
        return err;
      }
    );
    const pageData = this.router.getCurrentNavigation().extras?.state;

    if (pageData) {
      this.altprosubDetails = pageData?.prosubDetail;
      this.purchaseDetail = this.formPaymentDataForTopUp(this.altprosubDetails);
      this.loaded = true;
    }

    this.authService.getConstantsMsg$.subscribe((msg: Data) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });
    localStorage.removeItem("d");
    this.isPaymentDone = false;
    this.dateCalculator();
  }

  @HostListener("window:message", ["$event"])
  onMessage(e) {
    if (e && e?.data && e?.data?.for == "paymentDone") {
      this.afterNewCardPaymentDone();
    }
  }

  async ngOnDestroy() {
    this.authService.selectedlanguage$.unsubscribe();
    this.AuthPartialRegService.assignFreebieVoucher().unsubscribe();
    this.tokenValidaterSub?.unsubscribe();
    this.storedCardSubscription?.unsubscribe();
  }

  async ngOnInit() {
    await this.authService
      ?.getUid("AgeVerificationPage")
      ?.then((uid) => {
        this.userId = uid;
      })
      .catch((error) => {
        return error;
      });
    try {
      this.validateAgeVerifyForm();
      this.showDescription("wrap1");

      // Slight delay for date calculation (likely tied to UI rendering)
      setTimeout(() => {
        this.dateCalculator();
      }, 100);

      const offerDocPath = `/general_modules/offer_listing/offers/1152`;
      const offerDocRef = doc(this.firestore, offerDocPath);

      const offerSnap = await getDoc(offerDocRef);

      if (!offerSnap.exists()) {
        return;
      }

      const offer = offerSnap.data();

      const purchaseDetails = this.formPaymentDataForTopUp(offer);

      this.paymentService.insertCustomerPurchase(purchaseDetails, "").subscribe(
        (res) => {
          this.paymentDetail = res;
        },
        (error) => {
          const defaultMsg = {
            message: {
              line_1: "Something went wrong!",
              line_2: "",
            },
            style: {
              icon: "tick circle error.svg",
              type: "Error",
            },
          };
          this.authService.showToastMessage(null, defaultMsg);
        }
      );
    } catch (error) {
      throw error;
    }
  }

  formPaymentDataForTopUp(offer: Data) {
    return {
      prosub_id: offer?.prosub_id,
      phone: offer?.phone,
      prize: offer?.price,
      offers: offer,
      checkout: true,
      draw: "",
      game: "",
      line: "",
      offer_id: offer?.offer_id,
      real_name: "",
      page: "store",
      TP1: "",
      TP2: "",
      TP3: "",
      T_ID: "",
      other: "",
      vc: "",
    };
  }

  // Get data from Angular Firestore
  async getAngularFireStore(url: string, method: string) {
    try {
      const isOnline = await firstValueFrom(this.catchService.isOnline$);

      if (!isOnline) {
        return { success: false, code: 'OFFLINE', message: 'Offline' };
      }

      if (method === 'get') {
        const documentRef = doc(this.firestore, url);
        const documentSnapshot = await getDoc(documentRef);

        if (documentSnapshot.exists()) {
          return { success: true, data: documentSnapshot.data() };
        } else {
          return {
            success: false,
            code: 'DOCUMENT_NOT_FOUND',
            message: 'Document does not exist',
          };
        }
      } else {
        return { success: false, code: 'INVALID_METHOD', message: 'Invalid method' };
      }
    } catch (error) {
      console.error(error);
      return { success: false, code: 'UNKNOWN_ERROR', message: error.message };
    }
  }

  //below code is use to upload image
  onFileSelected(event): void {
    this.selectedFile = event.target.files[0];
    const fileReader = new FileReader();
    const file = event.target.files[0];
    if (file?.type != "image/png") {
      const translatedMessage = {
        message: {
          line_1: "Please upload file in image format.",
          line_2: "",
        },
        style: {
          icon: "tick circle error.svg",
          type: "Error",
        },
      };
      const defaultMsg = {
        message: {
          line_1: "Something went wrong!",
          line_2: "",
        },
        style: {
          icon: "tick circle success.png",
          type: "Success",
        },
      };
      try {
        this.authService.showToastMessage(translatedMessage, defaultMsg);
      } catch (error) {
        return error;
      }
      return;
    }
    if (file) {
      this.showLoadingSpinner();
      fileReader.readAsText(this.selectedFile);
      setTimeout(() => {
        this.selectedFile = file;
        this.hideLoadingSpinner();
      }, 1000);
    }
  }
  async showLoadingSpinner() {
    this.isLoading = true;
    const loading = await this.loadingController.create({
      message: "Uploading",
    });
    await loading.present();
  }
  hideLoadingSpinner() {
    this.isLoading = false;
    this.loadingController.dismiss();
  }

  showDescription(type: string) {
    if (type === "wrap1") {
      if (this.iswrap1Expanded) return;
      this.loading = true;
      this.iswrap1Expanded = true;
      this.iswrap2Expanded = false;
      const now = new Date();
      if (
        this.checkoutCreationTime &&
        this.checkoutCreationTime.getMinutes() + 10 > now.getMinutes()
      ) {
        this.loaded = true;
        this.loading = false;
        return;
      }
      this.loadIframe();
    } else if (type === "wrap2") {
      if (this.iswrap2Expanded) return;
      this.loading = false;
      this.loaded = false;
      this.iswrap2Expanded = true;
      this.iswrap1Expanded = false;
    }
  }
  backToTabs() {
    this.router.navigateByUrl("/mainTabs/tabs/home");
  }

  getSystemPreferenceOfferId() {
    const systemRef = doc(this.firestore, `/general_modules/${environment.mirrorPath}system_reference`);

    return from(getDoc(systemRef)).pipe(
      map(res => res.data()),
      switchMap(systemPreference => {
        if (systemPreference?.pre_auth_offer_id) {
          const offerRef = doc(
            this.firestore,
            `/general_modules/offer_listing/offers/${systemPreference.pre_auth_offer_id}`
          );
          return from(getDoc(offerRef)).pipe(
            map(offerSnap => offerSnap.data()),
            catchError(() => of({ price: this.defaultPrice })) // fallback if offer doc fails
          );
        }
        return of({ price: this.defaultPrice }); // fallback if no systemPreference or no offer id
      }),
      catchError(() => of({ price: this.defaultPrice })) // fallback if systemReference doc fails
    );
  }

  private loadIframe(): void {
    const systemRef = doc(this.firestore, 'general_modules/system_reference');

    from(getDoc(systemRef)).pipe(
      switchMap(r => {
        const preAuthOffer = r.data();
        this.loadingService.dismiss();

        return this.paymentService.insertCustomerPurchase(
          {
            offer_id: preAuthOffer?.pre_auth_offer_id,
            offers: { price: preAuthOffer?.pre_auth_amount },
          },
          '/api_post_request/insert_customer_purchase_account_add_card',
        ).pipe(
          switchMap((result: any) => {
            if (result?.status === 'rejected') {
              const msg = this.translatedToastMsg?.[result?.error_code]?.[this.selectedLanguage];
              this.authService.showToast(msg ? msg : 'Something went wrong!', 'Error', '');
              return of(null); // stop here
            }

            if (result?.response?.status === 'SUCCESS') {
              this.myuuid = uuidv4();
              const currency =
                this.userManagementService?.selectedCurrency ||
                CommonVariable?.preferredCurrency ||
                'GBP';

              return this.getSystemPreferenceOfferId().pipe(
                switchMap(offer => {
                  const additionalPayload = {
                    payment_type: this.paymentTypePreAuth,
                    sub_status: this.sub_status,
                  };
                  const paymentReason = 'rollover_jackpot';

                  return this.paymentService.getCheckoutId(
                    offer?.price || this.defaultPrice,
                    currency,
                    additionalPayload,
                    paymentReason,
                  ).pipe(
                    tap(async (res: any) => {
                      if (res.id) {
                        this.loading = false;
                        localStorage.setItem('c_id', res.id);
                        try {
                          await this.unloadPaymentWidget();
                        } catch (error) {
                          console.error('Error unloading widget:', error);
                        }
                        this.utilityService.loadScriptForPayment([res.paymentWidgetUrl]);
                        this.url = `https://eu-test.oppwa.com/v1/checkouts/${res.id}/payment`;
                      }
                    })
                  );
                }),
                tap(() => {
                  this.insertCustomerPurchaseRes = result;
                  this.purchaseDetail = result;
                  this.purchaseDetail['offer_id'] = preAuthOffer?.pre_auth_offer_id;
                  this.purchaseDetail['price'] = preAuthOffer?.pre_auth_amount;
                  this.loaded = true;
                }),
              );
            }

            return of(null); // fallback
          }),
        );
      }),
      catchError(error => {
        console.error('Error in loadIframe:', error);
        return of(null);
      })
    ).subscribe();
  }
  switchExpressDialog() {
    try {
      if (!this.selectedFile) {
        const translatedMessage = {
          message: {
            line_1: "Please upload file.",
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: "Error",
          },
        };
        const defaultMsg = {
          message: {
            line_1: "Something went wrong!",
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: "Error",
          },
        };
        try {
          this.authService.showToastMessage(translatedMessage, defaultMsg);
        } catch (error) {
          return error;
        }
        return;
      }
      if (this.selectedFile?.type != "image/png") {
        const translatedMessage = {
          message: {
            line_1: "Please upload file in image format.",
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: "Error",
          },
        };
        const defaultMsg = {
          message: {
            line_1: "Something went wrong!",
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: "Error",
          },
        };
        this.authService.showToastMessage(translatedMessage, defaultMsg);
        return;
      }

      const dialog = this.matDialog.open(SwitchExpressModalComponent, {
        backdropClass: "express-back-drop-color",
        panelClass: "express-dialog-size",
        hasBackdrop: true,
        disableClose: true,
        width: "90%",
      });
      dialog.afterClosed().subscribe((c) => {
        if (c === "express") {
          this.loading = true;
          this.iswrap1Expanded = true;
          this.iswrap2Expanded = false;
          const now = new Date();
          if (
            this.checkoutCreationTime &&
            this.checkoutCreationTime.getMinutes() + 10 > now.getMinutes()
          ) {
            this.loaded = true;
            this.loading = false;
            return;
          }
          this.loadIframe();
        }
      });
    } catch (error) {
      return error;
    }
  }
  load(): void {
    this.count++;
    if (this.count > 2) {
      this.isPaymentDone = true;
    }
  }

  // This function returns the card details of the card that is checked. If no cards are checked then it returns undefined.
  getCheckCardDetailId() {
    if (!this.storedCards) {
      return;
    }
    return this.storedCards?.find((x) => x.isChecked);
  }

  public onDateChange(event: Data): void {
    try {
      if (event?.detail?.value) {
        const formattedDate = format(new Date(event.detail.value), "MM/dd/yyyy");
        this.ageVerifyForm.get("dateOfBirth").patchValue(formattedDate);
        this.defaultDateOfBirth = event?.detail?.value;
        // use common dob for age-verification and free-reg-profile components
        localStorage.setItem("defaultDob", event?.detail?.value);
        if (!this.ageVerifyForm?.get('dateOfBirth')?.errors?.futureInvalidDate) {
          this.hideVerificationMethod = false;
          const payNowButton = document.querySelector('form.wpwl-form button');
          setTimeout(() => {
            if (payNowButton?.["innerText"]) {
              let verifyText = payNowButton?.["innerText"];
              this.translate.get(["age-verification.verify-now"])?.subscribe((res: string) => {
                verifyText = res["age-verification.verify-now"];
                payNowButton["innerText"] = verifyText;
              });
            }
          }, 100);
        } else {
          this.hideVerificationMethod = true;
        }
      }
    } catch (err) {
      return err
    }
  }

  public dateOfBirthValidation(control: FormControl) {
    try {
      if (!control.value) {
        return null; // No value entered, consider it as valid
      }
      let now = new Date();
      const dob = new Date(control.value);
      const eighteenYearsAgo: Date = new Date();
      eighteenYearsAgo.setFullYear(now.getFullYear() - 18);
      if (dob >= eighteenYearsAgo) {
        //Set the age verify input mark true
        this.checkInput = true;
        /* User is less than 18 years old */
        return { futureInvalidDate: true };
      }
      return null;
    } catch (error) {
      return error;
    }
  }
  private validateAgeVerifyForm(): void {
    this.ageVerifyForm = this.fb.group({
      dateOfBirth: [
        "",
        Validators.compose([this.dateOfBirthValidation.bind(this)]),
      ],
    });
  }
  dateCalculator() {
    const today = new Date();

    // Calculate the date 18 years ago from today
    const minDOB = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());

    // Format the minimum date for the input field
    this.defaultDateOfBirth = minDOB.toISOString().split("T")[0];
  }

  private manualLoginPayment(token: string, payment_status: Data) {
    this.tokenValidaterSub = this.authService.getV2CloudFunction("tokenvalidater", { token }).subscribe({
      next: (res) => {
        const { status, token, token_refresh } = res;
        if (status && token) {
          if (token_refresh) {
            localStorage.setItem(this.fbTokenKey, token);
          }
          this.angularFireAuth.signInWithCustomToken(token)
            .then(() => {
              this.angularFireAuth.currentUser.then((d) => {
                if (d) {
                  this.handleSuccessPayment(payment_status);
                } else {
                  const defaultMsg = {
                    message: {
                      line_1: "Something went wrong!",
                      line_2: "",
                    },
                    style: {
                      icon: "tick circle error.svg",
                      type: CommonVariable.error,
                    },
                  };
                  this.authService.showToastMessage({}, defaultMsg);
                }
              });
            }).catch((error) => {
              const logData = {
                creation_date: new Date(),
                local_fb_token: localStorage.getItem(this.fbTokenKey) || "Missing Token",
                error,
                page: "age-verification.page.ts",
                userId: localStorage.getItem(this.userIdKey) || "Missing User ID",
              };

              const path_id = "hbqZtgNd5muQnA8eI3xe";
              const doc_data = logData;
              const method = "create";

              this.authService.getV2CloudFunction("updatefirestoredoc", {
                path_id,
                doc_data,
                method,
              }).subscribe({
                error: (error) => {
                  console.error("Error updating manualLoginPayment list:", error);
                  return false;
                }
              });

              return false;
            });
        }
      },
      error: (err) => {
        return err;
      }
    });
  }

  afterNewCardPaymentDone() {
    try {
      const urlData = JSON.parse(localStorage.getItem("d"));
      if (!this.paymentReceived && urlData) {
        this.paymentReceived = true;
        this.paymentService
          .checkPaymentStatus(urlData?.id)
          .pipe(take(1))
          .subscribe((payment_status) => {
            this.payment_status = payment_status;
            if (payment_status) {
              this.angularFireAuth.currentUser.then((user) => {
                if (!user) {
                  let token = localStorage.getItem("fbToken");
                  if (token) {
                    this.manualLoginPayment(token, payment_status);
                  } else {
                    const interval = setInterval(() => {
                      let token = localStorage.getItem("fbToken");
                      if (token) {
                        clearInterval(interval);
                        this.manualLoginPayment(token, payment_status);
                      }
                    }, 1000);
                  }
                } else {
                  this.handleSuccessPayment(payment_status);
                }
              });
            }
          }, () => {
            this.handleError();
          });
      }
    } catch (error) {
      return error;
    }
  }

  private handleError() {
    const defaultMsg = {
      message: {
        line_1: "Unable to verify payment method!",
        line_2: "",
      },
      style: {
        icon: "tick circle error.svg",
        type: "Error",
      },
    };
    this.authService.showToastMessage(defaultMsg, defaultMsg);
  }

  private handleSuccessPayment(payment_status: Data) {
    try {
      const description = payment_status?.result?.description?.toLowerCase();
      const isSuccessfulPayment = description.includes("successfully") || description.includes("succeeded");

      if (isSuccessfulPayment) {
        const customerPurchaseJSON =
          this.paymentService.insertCustomerPurchaseRequestJson(
            { ...this.purchaseDetail, ...this.getCheckCardDetailId() },
            "/api_post_request/insert_customer_purchase_4c_payment"
          );

        // send preAuth true so that in paymill_card_payment_processing_mobile_app_async 
        // module call we will send sub_status: "pre_auth"
        const preAuth = true;

        this.paymentService
          .updatePaymentReqAndResNew(
            {
              ...this.purchaseDetail,
            },
            payment_status,
            customerPurchaseJSON,
            payment_status?.ndc,
            preAuth
          )
          .subscribe(async (sqlAPICall) => {
            if (sqlAPICall && sqlAPICall.response.status === "SUCCESS") {
              const userId = this.userId;

              if (userId) {
                const path_id = `yzF1Ss5eiMqnh91zQMtv`;
                const doc_data = { token_exists: true };
                const method = "update";

                this.authService.getV2CloudFunction("updatefirestoredoc", {
                  path_id,
                  doc_data,
                  method,
                }).subscribe({
                  error: (err) => {
                    return err;
                  },
                });
              }

              this.callInt2();
            }
          });
      } else {
        this.handleError();
      }
    } catch (error) {
      return error;
    }
  }
  // This function is for call interstitial 2 functionalities and redirect to specific page
  callInt2() {
    try {
      // Allot the user 2 freebie lines for successful pre-auth
      this.freebieLines();
      const customer_status = this.GTMService?.userIsNew ? "new" : "return";
      const currency = this.purchaseDetail?.offers?.currency || "GBP";

      this.GTMService.GTM_CJ_conversion(
        this.altprosubDetails?.price,
        currency,
        this.altprosubDetails?.offer_id,
        customer_status,
        CommonVariable.countryCode,
        this.purchaseDetail?.p_type,
        this.altprosubDetails?.prosub_id,
        this.insertCustomerPurchaseRes?.response?.customer_purchase_id
      );

      this.paymentService.getOptionalPage("").then(async (resp) => {
        const post_name = resp;
        if (post_name === "free-reg-complete-profile") {
          this.authService.userDetails$.pipe(take(1)).subscribe(
            (user: Data) => {
              this.userDetails = user;
              if (user?.minimal_required === true) {
                this.paymentService.freeRegJourneyStep = "free-reg-journey-4c";
              } else {
                this.paymentService.freeRegJourneyStep = "free-reg-journey-4c";
                this.paymentService.freeRegJourneySuccessURL = post_name;
                // This is Routing Parameters
                this.router.navigateByUrl(
                  `${post_name +
                  "?prosub_id=" +
                  this.Prosub_id +
                  "&" +
                  "TP1=" +
                  this.TP1 +
                  "&" +
                  "TP2=" +
                  this.Tp2 +
                  "&" +
                  "TP3=" +
                  this.TP3 +
                  "&" +
                  "T_ID=" +
                  this.T_ID}`
                );
              }
            },
            () => {
              this.authService.getConstantsMsg("1013").then((translatedMsg) => {
                const defaultMsg = {
                  message: {
                    line_1: "Something went wrong (user)",
                    line_2: "",
                  },
                  style: {
                    icon: "tick circle error.svg",
                    type: CommonVariable.error,
                  },
                };
                this.authService.showToastMessage(translatedMsg, defaultMsg);
              });
              this.router.navigate(["mainTabs/tabs/home"]);
            }
          );
        } else {
          this.spinnerAnimation = false;
          this.isPaymentDone = false;
          this.addingCard = false;
          this.addNewCardInProgress = false;
          localStorage.setItem("4cpage", "free-reg-step-4c");
          const path = post_name.split("?");
          const delayTime = 20000;
          const waitForStoredCards = new Promise<void>((resolve, reject) => {
            this.loadingService.present();
            setTimeout(async () => {
              const collectionRef = collection(
                this.firestore,
                `/users/${this.userId}/stored_card`
              );

              try {
                const snapshot = await getDocs(collectionRef);
                const documents = snapshot.docs.map((doc) => doc.data());
                if (documents.length > 0) {
                  resolve();
                } else {
                  reject(new Error("No documents found"));
                }
              } catch (error) {
                reject(error);
              }
            }, delayTime);
          });

          waitForStoredCards
            .then(() => {
              this.loadingService.dismiss();
              this.freeReg4cNavigation(path);
            })
            .catch(() => {
              this.loadingService.dismiss();
              this.freeReg4cNavigation(path);
            });
        }
      });
    } catch (error) {
      this.authService.getConstantsMsg("1014").then((translatedMsg) => {
        let errorMessage = "ERROR";
        this.translate.get(["age-verification.something-went-wrong"])?.subscribe((res: string) => {
          errorMessage = res["age-verification.something-went-wrong"];
        });
        const defaultMsg = {
          message: {
            line_1: errorMessage,
            line_2: "",
          },
          style: {
            icon: "tick circle error.svg",
            type: CommonVariable.error,
          },
        };
        this.authService.showToastMessage(translatedMsg, defaultMsg);
      });
    }
  }

  freeReg4cNavigation(path) {
    this.router.navigate([path[0]], {
      queryParams: {
        prosub_id: path[1].split("=")[1],
        TP1: this.TP1 ? this.TP1 : "null",
        TP2: this.Tp2 ? this.Tp2 : "null",
        TP3: this.TP3 ? this.TP3 : "null",
        T_ID: this.T_ID ? this.T_ID : "",
      },
    });
  }

  freebieLines() {
    if (!this.authService.freebieVoucherAssigned) {
      this.AuthPartialRegService.assignFreebieVoucher().subscribe(() => {
        this.authService.getConstantsMsg("1146").then((translatedMsg) => {
          const defaultMsg = {
            message: {
              line_1: "Congratulations!",
              line_2: "Your voucher wallet has 2 free lines",
            },
            style: {
              icon: "tick circle success.png",
              type: "Success",
            },
          };
          this.authService.showToastMessage(translatedMsg, defaultMsg);
        }).catch(error => {
          return error;
        });
      }, (error) => {
        return error;
      });
    }
  }

  private async unloadPaymentWidget(): Promise<void> {
    try {
      if (window.wpwl !== undefined && window.wpwl?.unload !== undefined) {
        await window.wpwl.unload();

        // Remove scripts using Renderer2
        const scripts = document.querySelectorAll('script[src*="static.min.js"]');
        scripts.forEach(script => {
          this.renderer.removeChild(document.body, script);
        });
      }
    } catch (error) {
      return error; // Rethrow the error for proper handling
    }
  }
}
